<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>
    <div class="statistic-content flex-item">
      <div class="equipment-item " v-for="(value, key) in equipment" :key="key">
        <img class="bgimg" :src="value.bg" alt="">
        <div>
          <p>{{ value.name }}</p>
          <p>{{ value.value }}
            <span class="unit">个</span>
          </p>
        </div>
        <img class="item-icon" :src="value.img" alt="">
        <div>
          <p>设备在线</p>
          <p>
            {{ value.value1 }}
            <span class="unit">个</span></p>
        </div>
        <img class="item-icon" :src="value.img1" alt="">
        <div>
          <p>设备离线</p>
          <p>
            {{ value.value2 }}
            <span class="unit">个</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>

export default {
  name: 'EquipmentDataStatistics',
  computed: {},
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '设备数据统计',
    },
  },
  watch: {},
  data() {
    return {
      equipment: this.$configer.equipment
    }
  },
  created() { },
  beforeDestroy() { },
  methods: {},
}
</script>
  